module.exports = __webpack_public_path__ + "img/二级页面海报室内机.134b74cf.jpg";